export default "__VITE_ASSET__Byp13l8U__"